import { createStore } from 'vuex'
import TeacherRankingAPI from '@/apis/business/teacher/teacher-ranking-api.js'
import { sessionStorageKeys } from '@/common/storage-keys.ts'
import { sessionStorage } from '@/utils/storage'

const modules = {}
const vuexModules = require.context(
  './modules',
  true,
  /[A-Za-z0-9-_,\s]+\.(js)$/i
)
const vuexCommonModules = require.context(
  '../common',
  true,
  /[A-Za-z0-9-_,\s]+\.(js)$/i
)

function mapModules (context) {
  const keys = context.keys()
  const values = keys.map(context)

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)

    if (matched && matched.length > 1) {
      const moduleName = matched[1]
      const module = values[i].default

      if (module) {
        modules[moduleName] = values[i].default
      }
    }
  }
}

mapModules(vuexModules)
mapModules(vuexCommonModules)

export default createStore({
  state: {
    avatar: '',
    listRankingGiftCard: {}, // ranking và giftCard của giáo viên
    isUpRank: false // Response đánh dấu có được tăng rank sau khi chia sẻ hay không
  },

  mutations: {
    setAvatar (state, newAvatar) {
      state.avatar = newAvatar
    },

    /**
     * @description Set giá trị cho listRankingGiftCard
     * @author lhlong
     */
    setListRankingGiftCard (state, param) {
      state.listRankingGiftCard = param
      sessionStorage.set(
        sessionStorageKeys.TEACHER_GIFT_CARD,
        state.listRankingGiftCard?.TeacherGiftCards
      )
      sessionStorage.set(
        sessionStorageKeys.TEACHER_RANKING,
        state.listRankingGiftCard?.TeacherRanking
      )
    },

    /**
     * @description set giá trị đánh dấu Uprank
     * @author lhlong
     */
    setIsUpRank (state, data) {
      state.isUpRank = data
    }
  },
  actions: {
    /**
     * Lấy số thông tin ranking và giftCard của giáo viên
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getRankingGiftCard (context, params) {
      return new Promise((resolve, reject) => {
        TeacherRankingAPI.getAsync('/ranking-gift-card')
          .then((res) => {
            context.commit('setListRankingGiftCard', res.Data)
            if (params) {
              context.commit('setIsUpRank', params)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  },
  modules: modules
})
